export default __webpack_public_path__ + "static/20-31cc54ae08594b52a409e49088c0a24d.jpg";